import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Text, Button, Paper, TextInput, PasswordInput } from "@mantine/core";

import { useForm } from "@mantine/form";
import Cookies from "js-cookie";

import {
  DefaultErrorNotification,
  DefaultSuccessNotification,
  validateEmail,
} from "../../Lib/Methods";

import { PerformRequest } from "../../Lib/usePerformRequest";
import { Endpoints } from "../../Lib/Endpoints";
import { AppContext } from "../../Context/AppContext";
import { LoginResponse, NonPaginatedResponse } from "../../Lib/Responses";

import "./styles.scss";
interface LoginFormProps {
  email: string;
  password: string;
}

export default function Login() {
  const navigate = useNavigate();
  const context = useContext(AppContext);
  const loginForm = useForm<LoginFormProps>({
    initialValues: {
      email: "",
      password: "",
    },
    validate: {
      email: (value) =>
        validateEmail(value) ? null : "Please enter a valid email!",
      password: (value) =>
        value.length >= 6 ? null : "Your password is at least SIX characters",
    },
  });

  const [isLoading, setLoading] = useState<boolean>(false);
  const LoginClient = async () => {
    const { hasErrors } = loginForm.validate();
    if (!hasErrors) {
      setLoading(true);
      const { email, password } = loginForm.values;
      const r = await PerformRequest<NonPaginatedResponse<LoginResponse>>({
        method: "POST",
        route: Endpoints.Login,
        data: { email: email.toLowerCase(), password },
      }).catch(() => {
        setLoading(false);
      });
      setLoading(false);
      if (r) {
        const { status, message, data } = r;
        if (status === 200) {
          DefaultSuccessNotification("Logged in successfully!", "Success");
          Cookies.set("token", data?.data?.token ?? "");
          navigate("/");
          if (context) {
            context.reloadProfile();
          }
        } else {
          DefaultErrorNotification(message);
        }
      }
    }
  };
  return (
    <div className="login-container">
      <Paper className="login" shadow="sm">
        <Text fw={500} fz="xl">
          Login To Continue
        </Text>
        <TextInput
          name="email"
          placeholder="Enter email address"
          w="100%"
          label="Email"
          {...loginForm.getInputProps("email")}
        />
        <PasswordInput
          placeholder="Enter password"
          w="100%"
          label="Password"
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              LoginClient();
            }
          }}
          {...loginForm.getInputProps("password")}
        />
        <Button
          fullWidth
          loading={isLoading}
          onClick={() => {
            LoginClient();
          }}
        >
          Login
        </Button>
        <div className="flex-row align-center width-100 justify-center">
          <Text>Don't have an account?</Text>
          &nbsp;&nbsp;
          <Link to="/register">
            <Text c="blue">Sign Up</Text>
          </Link>
        </div>
        {/* <Link to="/forgot">
          <Text c="dimmed" fz="sm">
            Forgot Password?
          </Text>
        </Link> */}
      </Paper>
    </div>
  );
}
